<template>
  <div class="overdue-page">
    <div class="exclamation-wrapper">
      <ExclamationCircleIcon size="24" color="#9F1313" />
    </div>
    <h3>
      Não identificamos o pagamento da parcela {{ installmentNumber | leadZeroFilter
      }}/{{ installmentNumbers | leadZeroFilter }}
    </h3>

    <p class="info">Entre em contato com a nossa equipe para regularizar sua pendência.</p>

    <a class="button" href="https://api.whatsapp.com/send?phone=5521971556988" target="_blank">
      <img src="https://cdn.parcelex.com.br/assets/v3/icons/rounded-whatsapp-white.svg" alt="Ícone de WhatsApp">
      Falar no Whatsapp
    </a>

    <a class="more-details hide-on-large" @click="onClickInDetails">Detalhes do pedido</a>
  </div>
</template>

<script>
import { ExclamationCircleIcon } from '@vue-hero-icons/outline';
import StringMixin from '@/mixins/string';

export default {
  name: 'overdue-page',
  props: {
    installmentNumber: {
      type: Number,
    },
    installmentNumbers: {
      type: Number,
    },
  },
  mixins: [StringMixin],
  methods: {
    onClickInDetails() {
      this.$emit('onClickInDetails');
    },
  },
  components: {
    ExclamationCircleIcon,
  },
};
</script>

<style lang="scss" scoped>
  .overdue-page {
    @media (min-width: $lg) {
      max-width: 402px;
    }

    .exclamation-wrapper {
      border-radius: 50%;
      background-color: #FBDFDF;
      width: 48px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
    }

    h3 {
      margin-bottom: 20px;
    }

    .info {
      @extend .body-regular;
      font-size: 16px;
      line-height: 24px;
      margin-bottom: 20px;
    }

    .button {
      box-sizing: border-box;
      display: flex;
      height: 38px;
      padding: 7px 16px 7px 12px;
      border-radius: 4px;

      background-color: var(--primary);

      display: flex;
      justify-content: center;
      align-items: center;
      gap: 8px;

      width: 100%;

      color: white;
      text-decoration: none;
      font-size: 16px;
      line-height: 24px;
      font-weight: 700;

      &:hover {
        background-color: var(--primary-dark);
      }

      @media (min-width: $lg) {
        width: fit-content;
      }
    }

    .more-details {
      @extend .small-regular;

      display: block;
      text-align: center;

      margin-top: 20px;

      color: var(--primary);

      font-size: 16px;
      line-height: 24px;
      font-weight: 400;
    }
  }
</style>
